<template>
  <div class="px-1">
    <InputIcon
      :value="value.icon"
      @input="updateValue($event, 'icon')"
      class="mb-4 mt-2"
    ></InputIcon>
    <div v-for="input in form" :key="input.label">
      <InputTextField
        :value="value[input.key]"
        :label="input.label"
        :suffix="input.suffix"
        :type="input.type"
        :label-size="12"
        @input="updateValue($event, input.key)"
      ></InputTextField>
    </div>
  </div>
</template>

<script>
import { schemas } from "data-dictionary";

export default {
  name: "VisNodeForm",
  components: {
    InputIcon: () => import("@/components/inputs/InputIcon.vue"),
    InputTextField: () => import("@/components/inputs/InputTextField.vue"),
  },
  mixins: [],
  props: {
    value: { type: Object, required: false, default: () => ({}) },
  },
  data() {
    return {
      schemaNode: {
        ...schemas.find((v) => v.$id === "node.schema.json").properties,
      },
    };
  },
  computed: {
    form() {
      return Object.entries(this.schemaNode)
        .filter(([key]) => !["id", "active"].includes(key))
        .map(([key, schema]) => {
          return {
            key,
            label: schema.title,
            suffix: schema.unit,
            type: this.getTypeFromSchema(schema.type),
          };
        });
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    getTypeFromSchema(type) {
      if (Array.isArray(type)) {
        if (type.includes("number")) {
          return "number";
        }
        if (type.includes("string")) {
          return "text";
        }
      }
      return type;
    },
    updateValue($e, key) {
      const valueCopy = this.value;
      valueCopy[key] = $e;
      this.$emit("input", valueCopy);
    },
  },
};
</script>

<style></style>
